/**
 * Wave Selfcare — Popup roulette
 * Fichier : assets/wave-roulette.js
 *
 * Élément personnalisé <wave-roulette>. Toute la configuration vient du bloc
 * <script type="application/json" data-wvr-config> rendu par la section, donc
 * rien n'est à modifier ici : tout se règle depuis l'éditeur de thème.
 *
 * Déroulé : la roue tourne librement -> l'e-mail est demandé après le gain
 * -> le code de réduction est révélé.
 */
(function () {
  'use strict';

  if (customElements.get('wave-roulette')) return;

  var STORAGE_KEY = 'wave_roulette_state_v1';
  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])';

  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (e) {
      /* navigation privée : on ignore */
    }
  }

  function daysSince(timestamp) {
    return (Date.now() - timestamp) / 86400000;
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
  }

  /** Tirage pondéré. Renvoie l'index du segment gagnant. */
  function pickIndex(segments) {
    var total = 0;
    var i;
    for (i = 0; i < segments.length; i++) total += Math.max(0, segments[i].weight || 0);
    if (total <= 0) return Math.floor(Math.random() * segments.length);

    var roll = Math.random() * total;
    for (i = 0; i < segments.length; i++) {
      roll -= Math.max(0, segments[i].weight || 0);
      if (roll <= 0) return i;
    }
    return segments.length - 1;
  }

  /** Quotas déclarés dans l'éditeur, par identifiant de lot. */
  function capsFromSegments(segments) {
    var caps = {};
    (segments || []).forEach(function (segment) {
      var stock = segment && segment.stock;
      if (segment && segment.prizeId && typeof stock === 'number' && stock >= 0) {
        caps[segment.prizeId] = stock;
      }
    });
    return caps;
  }

  class WaveRouletteElement extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      var configEl = this.querySelector('[data-wvr-config]');
      if (!configEl) return;

      try {
        this.config = JSON.parse(configEl.textContent);
      } catch (e) {
        return;
      }

      this.segments = this.config.segments || [];
      if (!this.segments.length) return;

      // Poids d'origine : on y revient dès qu'un lot redevient disponible.
      this.baseWeights = this.segments.map(function (segment) {
        return segment.weight;
      });
      this.caps = capsFromSegments(this.segments);

      this.portal = this.querySelector('[data-wvr-portal]');
      if (!this.portal) return;

      // Le portail (pastille + modale) est sorti vers <body> : un ancêtre
      // transformé casserait sinon le position: fixed.
      document.body.appendChild(this.portal);

      this.modal = this.one('[data-wvr-modal]');
      if (!this.modal) return;

      this.dialog = this.one('[data-wvr-dialog]');
      this.wheel = this.one('[data-wvr-wheel]');
      this.tab = this.one('[data-wvr-tab]');
      this.form = this.one('form.wvr-form');
      this.emailInput = this.one('[data-wvr-email]');
      this.consentInput = this.one('[data-wvr-consent]');
      this.errorEl = this.one('[data-wvr-error]');
      this.rotation = 0;
      this.spinning = false;
      this.result = null;
      this.lastFocus = null;

      this.designMode = !!(window.Shopify && window.Shopify.designMode);
      this.state = this.designMode ? null : readState();

      this.bind();
      this.restore();
      this.scheduleAutoOpen();
      this.refreshAvailability();
    }

    /**
     * Demande au service quels lots sont encore disponibles ce mois-ci et met
     * le poids des lots épuisés à zéro : la roue cesse de s'arrêter dessus.
     * Si le service est injoignable, on garde les poids d'origine — mieux vaut
     * une roue normale qu'une roue bloquée.
     */
    refreshAvailability() {
      if (!this.config.endpoint) return;
      var self = this;

      var separator = this.config.endpoint.indexOf('?') === -1 ? '?' : '&';
      var url = this.config.endpoint + separator + 'stock=1';
      if (Object.keys(this.caps).length) {
        url += '&caps=' + encodeURIComponent(JSON.stringify(this.caps));
      }

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data || !data.stock) return;

          var restant = 0;
          self.segments.forEach(function (segment, index) {
            var info = segment.prizeId ? data.stock[segment.prizeId] : null;
            if (info && info.available === false) {
              segment.weight = 0;
            } else {
              segment.weight = self.baseWeights[index];
            }
            restant += Math.max(0, segment.weight || 0);
          });

          // Garde-fou : si tout tombait à zéro, la roue ne pourrait plus
          // tirer. On rétablit alors les poids d'origine.
          if (restant <= 0) {
            self.segments.forEach(function (segment, index) {
              segment.weight = self.baseWeights[index];
            });
          }
        })
        .catch(function () {
          /* service injoignable : poids d'origine conservés */
        });
    }

    /* ---------------------------------------------------------------- */

    /** Cherche dans l'élément et dans le portail déplacé vers <body>. */
    all(selector) {
      var found = Array.prototype.slice.call(this.querySelectorAll(selector));
      if (this.portal && !this.contains(this.portal)) {
        if (this.portal.matches(selector)) found.push(this.portal);
        found = found.concat(Array.prototype.slice.call(this.portal.querySelectorAll(selector)));
      }
      return found;
    }

    one(selector) {
      return this.all(selector)[0] || null;
    }

    /* ---------------------------------------------------------------- */

    bind() {
      var self = this;

      this.all('[data-wvr-spin]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.spin();
        });
      });

      this.all('[data-wvr-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.close(true);
        });
      });

      if (this.tab) {
        this.tab.addEventListener('click', function () {
          self.open();
        });
      }

      if (this.wheel) {
        this.wheel.addEventListener('transitionend', function (event) {
          if (event.propertyName === 'transform') self.onSpinEnd();
        });
      }

      if (this.form) {
        this.form.addEventListener('submit', function (event) {
          event.preventDefault();
          self.submitEmail();
        });
      }

      var copyBtn = this.one('[data-wvr-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          self.copyCode(copyBtn);
        });
      }

      this.onKeydown = function (event) {
        if (!self.isOpen) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close(true);
        } else if (event.key === 'Tab') {
          self.trapFocus(event);
        }
      };
      document.addEventListener('keydown', this.onKeydown);

      // Éditeur de thème : ouvrir dès que la section est sélectionnée.
      if (this.designMode) {
        document.addEventListener('shopify:section:select', function (event) {
          if (self.closest('.shopify-section') === event.target) self.open();
        });
        document.addEventListener('shopify:section:deselect', function (event) {
          if (self.closest('.shopify-section') === event.target) self.close(false);
        });
      }
    }

    /** Réaffiche un code déjà gagné lors d'une visite précédente. */
    restore() {
      if (!this.state || this.state.status !== 'won') return;

      this.result = { label: this.state.label, prize: this.state.prize, code: this.state.code };
      this.fillPrize();
      this.showPanel(this.state.code ? 'code' : 'lose');

      if (this.config.hideAfterWin && this.tab) this.tab.hidden = true;
    }

    scheduleAutoOpen() {
      if (this.designMode) return;
      if (!this.config.autoOpen) return;
      if (this.state) {
        if (this.state.status === 'won') return;
        if (this.config.frequencyDays > 0 && daysSince(this.state.ts) < this.config.frequencyDays) return;
      }

      var self = this;
      this.autoTimer = setTimeout(function () {
        self.open();
      }, Math.max(0, this.config.delay) * 1000);
    }

    /* ---------------------------------------------------------------- */

    open() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.lastFocus = document.activeElement;
      clearTimeout(this.autoTimer);

      this.modal.classList.add('is-open');
      this.modal.removeAttribute('aria-hidden');
      document.documentElement.style.overflow = 'hidden';

      var target = this.dialog.querySelector(FOCUSABLE);
      if (target) target.focus({ preventScroll: true });
    }

    close(remember) {
      if (!this.isOpen) return;
      this.isOpen = false;

      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';

      if (remember && !this.designMode && (!this.state || this.state.status !== 'won')) {
        this.state = { status: 'closed', ts: Date.now() };
        writeState(this.state);
      }

      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    }

    trapFocus(event) {
      var items = Array.prototype.filter.call(this.dialog.querySelectorAll(FOCUSABLE), function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------------------------------------------------------------- */

    spin() {
      if (this.spinning) return;
      if (this.state && this.state.status === 'won' && !this.designMode) return;

      this.spinning = true;
      this.all('[data-wvr-spin]').forEach(function (el) {
        el.disabled = true;
      });

      var index = pickIndex(this.segments);
      this.result = this.segments[index];

      var step = 360 / this.segments.length;
      var centre = index * step + step / 2;
      // Petit décalage aléatoire pour ne pas s'arrêter pile au milieu.
      var jitter = (Math.random() - 0.5) * step * 0.55;
      var turns = 360 * (this.config.turns || 6);

      // On repart toujours de la position courante en ajoutant des tours entiers.
      var current = this.rotation % 360;
      var wanted = ((-centre - jitter) % 360 + 360) % 360;
      var delta = ((wanted - current) % 360 + 360) % 360;

      this.rotation = this.rotation + turns + delta;
      this.wheel.style.setProperty('--wvr-rot', this.rotation + 'deg');

      var live = this.one('[data-wvr-live]');
      if (live) live.textContent = this.config.spinningLabel || '';

      // Filet de sécurité si transitionend ne se déclenche pas.
      var self = this;
      clearTimeout(this.spinTimer);
      this.spinTimer = setTimeout(function () {
        self.onSpinEnd();
      }, (parseFloat(this.config.duration) || 5) * 1000 + 900);
    }

    onSpinEnd() {
      if (!this.spinning) return;
      this.spinning = false;
      clearTimeout(this.spinTimer);

      // Dans l'éditeur, on peut relancer la roue autant de fois qu'on veut.
      if (this.designMode) {
        this.all('[data-wvr-spin]').forEach(function (el) {
          el.disabled = false;
        });
      }

      var won = !!(this.result && this.result.isWin && (this.result.code || (this.config.endpoint && this.result.prizeId)));

      if (!this.designMode) {
        this.state = {
          status: won ? 'pending' : 'lost',
          ts: Date.now(),
          label: this.result.label,
          prize: this.result.prize,
        };
        writeState(this.state);
      }

      this.fillPrize();

      if (won) {
        this.showPanel('email');
        if (this.config.confetti) this.confetti();
        if (this.emailInput) this.emailInput.focus({ preventScroll: true });
      } else {
        this.showPanel('lose');
      }

      var live = this.one('[data-wvr-live]');
      if (live) live.textContent = (won ? this.config.winTitle : this.config.loseTitle) + ' ' + (this.result.prize || this.result.label || '');
    }

    fillPrize() {
      var text = (this.result && (this.result.prize || this.result.label)) || '';
      this.all('[data-wvr-prize]').forEach(function (el) {
        el.textContent = text;
      });

      var code = (this.result && this.result.code) || '';
      this.all('[data-wvr-code]').forEach(function (el) {
        el.textContent = code;
      });

      var hidden = this.one('[data-wvr-prize-field]');
      if (hidden) {
        var tags = [this.config.baseTag || 'newsletter', 'roulette'];
        if (code) tags.push('roulette-' + String(code).toLowerCase());
        hidden.value = tags.join(',');
      }
    }

    showPanel(name) {
      this.all('[data-wvr-panel]').forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-wvr-panel') === name);
      });
    }

    /* ---------------------------------------------------------------- */

    submitEmail() {
      var self = this;
      var email = this.emailInput ? this.emailInput.value : '';

      if (!isValidEmail(email)) {
        this.showError(this.config.errorEmail, this.emailInput);
        return;
      }

      if (this.consentInput && !this.consentInput.checked) {
        this.showError(this.config.errorConsent, this.consentInput);
        return;
      }

      this.showError('', null);

      var submitBtn = this.form.querySelector('[data-wvr-submit]');
      if (submitBtn) {
        submitBtn.dataset.idle = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = this.config.sendingLabel || submitBtn.textContent;
      }

      var restoreButton = function () {
        if (!submitBtn) return;
        submitBtn.disabled = false;
        if (submitBtn.dataset.idle) submitBtn.textContent = submitBtn.dataset.idle;
      };

      var reveal = function () {
        if (!self.designMode) {
          self.state = {
            status: 'won',
            ts: Date.now(),
            label: self.result.label,
            prize: self.result.prize,
            code: self.result.code,
          };
          writeState(self.state);
        }
        if (self.config.hideAfterWin && self.tab) self.tab.hidden = true;
        self.showPanel('code');
      };

      // Mode codes uniques : le service génère un code nominatif à usage
      // unique et nous le renvoie. C'est lui qui inscrit aussi le client.
      if (this.config.endpoint && this.result && this.result.prizeId) {
        fetch(this.config.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email.trim(), prize: this.result.prizeId, caps: this.caps }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              return { ok: response.ok, data: data };
            });
          })
          .then(function (result) {
            if (!result.ok || !result.data.code) throw new Error(result.data.error || 'server_error');
            // Le serveur a le dernier mot sur le lot réellement accordé
            // (quota épuisé => lot de repli). On affiche ce qu'il a donné,
            // jamais ce que la roue avait annoncé.
            var granted = { code: result.data.code };
            if (result.data.label) {
              granted.prize = result.data.label;
              granted.label = result.data.label;
            }
            self.result = Object.assign({}, self.result, granted);
            self.fillPrize();
            reveal();
          })
          .catch(function () {
            restoreButton();
            self.showError(self.config.errorServer, null);
          });
        return;
      }

      // Mode codes fixes : on poste le vrai formulaire client Shopify (champs
      // cachés et protection anti-robot compris) sans recharger la page.
      fetch(this.form.action, {
        method: 'POST',
        body: new FormData(this.form),
        headers: { Accept: 'text/html' },
      })
        .then(reveal)
        .catch(function () {
          // L'inscription a pu échouer côté réseau : on ne pénalise pas le
          // visiteur, il obtient quand même son code.
          reveal();
        });
    }

    showError(message, field) {
      if (this.errorEl) {
        this.errorEl.textContent = message || '';
        this.errorEl.hidden = !message;
      }
      if (this.emailInput) this.emailInput.setAttribute('aria-invalid', field === this.emailInput ? 'true' : 'false');
      if (field && field.focus) field.focus({ preventScroll: true });
    }

    copyCode(button) {
      var code = (this.result && this.result.code) || '';
      if (!code) return;

      var done = function () {
        var original = button.dataset.original || button.textContent;
        button.dataset.original = original;
        button.textContent = button.getAttribute('data-copied-label') || original;
        setTimeout(function () {
          button.textContent = original;
        }, 2200);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        var helper = document.createElement('textarea');
        helper.value = code;
        helper.setAttribute('readonly', '');
        helper.style.position = 'fixed';
        helper.style.opacity = '0';
        document.body.appendChild(helper);
        helper.select();
        try {
          document.execCommand('copy');
        } catch (e) {
          /* ignore */
        }
        document.body.removeChild(helper);
        done();
      }
    }

    confetti() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var host = this.one('[data-wvr-confetti]');
      if (!host) return;

      var colours = this.config.confettiColours || ['#9a5d48', '#d6cec1', '#ec5b38', '#433732', '#FFCEC3'];
      host.innerHTML = '';

      for (var i = 0; i < 44; i++) {
        var piece = document.createElement('span');
        piece.style.left = Math.random() * 100 + '%';
        piece.style.background = colours[i % colours.length];
        piece.style.animationDuration = 2.4 + Math.random() * 2 + 's';
        piece.style.animationDelay = Math.random() * 0.6 + 's';
        piece.style.transform = 'rotate(' + Math.random() * 360 + 'deg)';
        host.appendChild(piece);
      }

      setTimeout(function () {
        host.innerHTML = '';
      }, 6000);
    }

    disconnectedCallback() {
      clearTimeout(this.autoTimer);
      clearTimeout(this.spinTimer);
      document.removeEventListener('keydown', this.onKeydown);
      document.documentElement.style.overflow = '';
      if (this.portal && !this.contains(this.portal) && this.portal.parentElement) {
        this.portal.parentElement.removeChild(this.portal);
      }
    }
  }

  customElements.define('wave-roulette', WaveRouletteElement);
})();
